import { useEffect, useState } from "react";

import {
    Container,
    ContentWrapper,
    InfoSidebar,
    ProjectContent,
    ImageBlock,
    NavLinks,
    NavLinkItem,
} from "../styles/SingleItemStyle";

import PageLayout from "../components/PageLayout";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer";

const FurnitureItem = () => {
    const { id } = useParams();
    const [furnitures, setFurnitures] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch product data
        axios.get('http://localhost:8000/furniture')
            .then(response => {
                setFurnitures(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching products:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    const index = furnitures.findIndex((furniture) => furniture._id === id);

    const prev = index > 0 ? furnitures[index - 1] : null;
    const next = index < furnitures.length - 1 ? furnitures[index + 1] : null;

    return (
        <PageLayout>
            <Container>
                <ContentWrapper>
                    <InfoSidebar>
                        <h2>{furnitures[index].title}</h2>

                        {/* <h6>{furniture[index].location}</h6> */}

                        {/* <h6>{Array.isArray(furniture[index].tags) ? furniture[index].tags.join(", ") : ""}</h6> */}

                        <p> {furnitures[index].description} </p>
                        <p> {furnitures[index].details} </p>

                    </InfoSidebar>
                    <ProjectContent>
                        <ProjectContent>
                            {Array.isArray(furnitures[index]?.images) ? (
                                furnitures[index].images.map((imgUrl, imgIndex) => (
                                    <ImageBlock key={imgIndex} src={imgUrl} alt={`Project Image ${imgIndex + 1}`} />
                                ))
                            ) : (
                                <p>No images available</p>
                            )}
                        </ProjectContent>
                    </ProjectContent>
                </ContentWrapper>
                <NavLinks>
                    {prev
                        ? <NavLinkItem as={Link} to={`/furniture/${prev._id}`}>← {prev.title}</NavLinkItem>
                        : <div />
                    }
                    <NavLinkItem as={Link} to="/furniture">Back to All Furniture</NavLinkItem>
                    {next
                        ? <NavLinkItem as={Link} to={`/furniture/${next._id}`}>{next.title} →</NavLinkItem>
                        : <div />
                    }
                </NavLinks>
                <Footer />
            </Container>
        </PageLayout>
    );
}

export default FurnitureItem;